<template>
  <div class="text-gray-700">
    {{ userName }}
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const userName = props.data?.user_name ?? '';
</script>
